var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/* eslint-disable react/display-name */
import React from 'react';
import { useEffect, useState } from 'react';
var withWindowDimensions = function (WrappedComponent) {
    return function (props) {
        var _a = __read(useState({
            width: 380,
            height: 640
        }), 2), windowDimensions = _a[0], setWindowDimensions = _a[1];
        useEffect(function () {
            function handleResize() {
                setWindowDimensions({
                    width: window.innerWidth,
                    height: window.innerHeight
                });
            }
            handleResize();
            window.addEventListener('resize', handleResize);
            return function () {
                window.removeEventListener('resize', handleResize);
            };
        }, []);
        return (React.createElement(React.Fragment, null,
            React.createElement(WrappedComponent, __assign({}, props, { windowWidth: windowDimensions.width, windowHeight: windowDimensions.height, isMobileSized: windowDimensions.width < 700, isTabSized: windowDimensions.width < 1000 && windowDimensions.width > 700 }))));
    };
};
export default withWindowDimensions;
//# sourceMappingURL=withWindowDimensions.js.map